import { applyMiddleware, createStore, compose } from 'redux';
// import logger from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [
  thunk,
];
if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
  // middleware.push(logger());
}

const store = createStore(
  rootReducer,  
  composeEnhancers(
  	applyMiddleware(...middleware),
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js